"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuarry = exports.QuarryProvider = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const bn_js_1 = __importDefault(require("bn.js"));
const react_1 = require("react");
const unstated_next_1 = require("unstated-next");
const rewarder_1 = require("../rewarder");
const useUserAssociatedTokenAccounts_1 = require("../useUserAssociatedTokenAccounts");
const useQuarryInternal = (args = {}) => {
    var _a;
    const { quarry } = args;
    const { quarries, rewards, rewardToken } = (0, rewarder_1.useRewarder)();
    if (!quarry) {
        throw new Error("no quarry");
    }
    const index = quarries.findIndex((q) => q.key.equals(quarry.key));
    if (index === -1) {
        throw new Error("no quarry");
    }
    const [userStakedTokenBalance] = (0, useUserAssociatedTokenAccounts_1.useUserAssociatedTokenAccounts)([
        quarry.stakedToken,
    ]);
    const { miner } = quarry;
    const stakedAmount = (0, react_1.useMemo)(() => {
        return quarry && miner
            ? new token_utils_1.TokenAmount(quarry.stakedToken, miner.accountInfo.data.balance)
            : miner === undefined
                ? undefined
                : null;
    }, [miner, quarry]);
    const totalDeposits = (0, react_1.useMemo)(() => {
        return new token_utils_1.TokenAmount(quarry.stakedToken, quarry.quarry.accountInfo.data.totalTokensDeposited);
    }, [quarry]);
    const rewardsPerDay = (0, react_1.useMemo)(() => {
        var _a;
        if (!rewardToken) {
            return null;
        }
        const ratePerSecond = (_a = rewards.rates) === null || _a === void 0 ? void 0 : _a.pools[index];
        if (typeof ratePerSecond !== "number") {
            return null;
        }
        return token_utils_1.TokenAmount.parse(rewardToken, (ratePerSecond * 86400).toString());
    }, [index, rewardToken, (_a = rewards.rates) === null || _a === void 0 ? void 0 : _a.pools]);
    const totalRewardsPerDay = (0, react_1.useMemo)(() => {
        if (!rewardToken) {
            return null;
        }
        return new token_utils_1.TokenAmount(rewardToken, quarry.quarry.accountInfo.data.annualRewardsRate.div(new bn_js_1.default(365)));
    }, [quarry.quarry.accountInfo.data.annualRewardsRate, rewardToken]);
    return {
        quarry,
        stakedToken: quarry.stakedToken,
        userStakedTokenBalance,
        index,
        stakedAmount,
        rewardsPerDay,
        totalDeposits,
        totalRewardsPerDay,
    };
};
_a = (0, unstated_next_1.createContainer)(useQuarryInternal), exports.QuarryProvider = _a.Provider, exports.useQuarry = _a.useContainer;
//# sourceMappingURL=context.js.map